'use client';

type AnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

const STORAGE_KEY = 'laposte-webar-analytics';

export function trackClientEvent(eventName: string, payload: AnalyticsPayload = {}) {
  const event = {
    event: eventName,
    payload,
    timestamp: new Date().toISOString()
  };

  if (typeof window !== 'undefined') {
    const dataLayerTarget = window as Window & { dataLayer?: unknown[] };
    if (Array.isArray(dataLayerTarget.dataLayer)) {
      dataLayerTarget.dataLayer.push(event);
    }

    try {
      const previous = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]') as unknown[];
      const next = [...previous.slice(-49), event];
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // Ignore analytics persistence failures in the MVP.
    }
  }
}
